var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SeoPillarLandingPage',{attrs:{"content":_vm.$t('seoPillarUtm'),"faq-src":"/seo-faq/gerador-de-utm.json"}})}
var staticRenderFns = []

export { render, staticRenderFns }